module.exports = __webpack_public_path__ + "img/twitter_btn.8d7ddbca.svg";